
import Theme from '@/shared/app/model/theme/Theme';
import Dataset from '@/shared/data/model/Dataset';
import DatasetValue from '@/shared/data/model/DatasetValue';
import _, { isFunction, isString } from 'lodash';
import { mixins } from 'vue-class-component';
import { Component, Vue } from 'vue-property-decorator';
import { EventBus } from '../connector/EventBus';
import AppConstants from '../model/AppConstants';
import Template from '../model/templating/Template';
import defaultTheme from '../model/theme/default';
import Formatter from './Formatter';

const props = Vue.extend({
  props: {
    pTemplate: {
      required: false,
    },
    activated: {
      required: false,
      type: Boolean,
      default: true,
    },
  },
});

@Component({})
export default class Base extends mixins(Vue, props) {
  pTemplate: Template | undefined;

  public dataset(name: string): Dataset {
    if (this.template?.datasets) {
      const datasetFromTemplate = this.template.datasets[name];
      if (typeof datasetFromTemplate === 'object')
        return datasetFromTemplate as Dataset;
      if (typeof datasetFromTemplate === 'string')
        return this.$store.getters.all(datasetFromTemplate);
    }
    return this.$store.getters.all(name);
  }

  indexedDataset(dataset: string, prefix: string): Dataset[] {
    // Dataset entier
    const data = this.dataset(dataset);
    const rx = new RegExp(`^${prefix}(\\d+)_(\\w+)$`);
    // On match tous les résultats
    let keysMatches = Object.keys(data).map((key) => rx.exec(key));
    if (keysMatches) {
      keysMatches = keysMatches.filter((m) => m !== null);
      const matches: { [index: string]: Dataset } = {};
      keysMatches.forEach((keyMatch) => {
        if (!keyMatch) return;
        const originalkey = keyMatch[0];
        const index = keyMatch[1];
        const key = keyMatch[2];
        if (originalkey && index && key) {
          if (!matches[index]) matches[index] = {};
          matches[index][key] = data[originalkey];
        }
      });
      return Object.values(matches);
    }
    return [];
  }

  emitDone() {
    if (this.$parent?.callDone && isFunction(this.$parent.callDone)) {
      this.$parent.callDone(this.pTemplate);
    } else if (
      this.$parent?.$parent?.callDone &&
      isFunction(this.$parent?.$parent?.callDone)
    ) {
      this.$parent.$parent.callDone(this.pTemplate);
    }
    if (isString(this.config.doneEvent)) {
      EventBus.$emit(this.config.doneEvent, this.pTemplate);
    }
  }

  callDone() {
    // Comportement par défaut, faire suivre...
    this.emitDone();
  }

  get config() {
    return _.merge({}, this.template?.config, this.dataset('config'));
  }

  get theme(): Theme {
    // Thème : depuis la config du composant
    if (
      Object.keys(this.template?.datasets || {}).includes(
        AppConstants.THEME_DATASET_NAME,
      )
    )
      return this.dataset(AppConstants.THEME_DATASET_NAME) as Theme;
    // Thème : depuis le parent s'il existe
    let instanceToTest;
    if (this.$parent instanceof Base) instanceToTest = this.$parent;
    else if (this.$parent?.$parent instanceof Base)
      instanceToTest = this.$parent.$parent;
    if (instanceToTest) {
      return instanceToTest.theme;
    }
    // Thème : depuis les données root
    if (
      Object.keys(this.$store.state.datasets).includes(
        AppConstants.THEME_DATASET_NAME,
      )
    )
      return this.$store.getters.all(AppConstants.THEME_DATASET_NAME);
    // Thème : par défaut...
    return defaultTheme;
  }

  get template() {
    return this.pTemplate;
  }

  get sizeFactor() {
    return Number(this.config.sizeFactor) || AppConstants.DEFAULT_SIZE_FACTOR;
  }

  bySizeFactor(value: number) {
    return value * this.sizeFactor;
  }

  formatPrice(price: DatasetValue): string {
    return Formatter.formatPrice(
      price?.toString(),
      this.dataset(AppConstants.APP_DATASET_NAME).priceFormat?.toString(),
    );
  }

  formatPrice2(price2: DatasetValue): string {
    return Formatter.formatPrice(
      price2?.toString(),
      this.dataset(AppConstants.APP_DATASET_NAME).price2Format?.toString(),
    );
  }

  /*
   * Calcule la valeur de la font-size pour l'élément root (utilisé ensuite par toutes les unités "rem")
   * Cette solution permet de conserver une valeur correcte y compris quand la largeur de l'écran correspond à hauteur de la page (rotation CSS portrait)
   */
  get rootFontsize() {
    return this.$store.getters.rootFontSize;
    // return Math.round(0.008 * Math.max(window.innerHeight, window.innerWidth));
  }

  get $app() {
    return this.dataset(AppConstants.APP_DATASET_NAME);
  }
}
